import { Icon } from '@/new/components/icon';
import { Relevance } from '@/types';

const getRelevanceInfo = (relevance: Relevance) => {
  switch (relevance) {
    case Relevance.YES:
      return {
        text: 'Relevant',
        color: 'text-green-600',
        icon: <Icon className="lucide--circle-check h-4 w-4 text-green-600" />,
      };
    case Relevance.MAYBE:
      return {
        text: 'Maybe Relevant',
        color: 'text-orange-400',
        icon: <Icon className="lucide--circle-help h-4 w-4 text-orange-400" />,
      };
    case Relevance.NO:
      return {
        text: 'Not Relevant',
        color: 'text-red-600',
        icon: <Icon className="lucide--circle-x h-4 w-4 text-red-600" />,
      };
    default:
      return null;
  }
};

export const RelevanceIndicator = ({ relevance }: { relevance: Relevance }) => {
  const relevanceInfo = getRelevanceInfo(relevance);

  if (!relevanceInfo) return null;

  const { text, color, icon } = relevanceInfo;

  return (
    <p className={`flex w-max items-center justify-end gap-1.25 text-xs ${color}`}>
      {icon}
      <span className="pt-0.25 text-gray-600">{text}</span>
    </p>
  );
};
